import {
  login,
  logout,
  register,
  getUserInfo
} from '@/api/user.js'
import { isCheckToken } from '@/api/auth.js'
import { error, warning, success } from '@/utils/message'
import { MessageBox } from 'element-ui'
import {
  getItem,
  saveItem,
  saveItemObject,
  getItemObject,
  removeItem
} from '@/utils/storage'
import router from '@/router'
const CONFIG = require('@/utils/config')
const STORAGE_KEY = CONFIG.STORAGE_KEY
const TOKEN_KEY = CONFIG.TOKEN_KEY


export default {
  namespaced: true,
  state: () => ({
    // 用户 token
    token: getItem(TOKEN_KEY) || '',
    // 用户信息
    userInfo: getItemObject(STORAGE_KEY) || ''
  }),
  getters: {
    // 进行登陆判定, 并跳转
    isLogin(state) {
      if (state.token) {
        return true
      } else {
        return false
      }
    }
  },
  mutations: {
    // 保存 token 到 vuex
    setToken(state, token) {
      state.token = token
      this.commit('auth/saveToken')
    },
    // 保存 token 到 本地存储
    saveToken(state) {
      saveItem(TOKEN_KEY, state.token)
    },
    // 保存 用户信息 到  vuex
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      this.commit('auth/saveUserInfo')
    },
    // 保存 用户信息 到本地存储
    saveUserInfo(state) {
      saveItemObject(STORAGE_KEY, state.userInfo)
    },
    // 删除用户信息
    removeUserInfo(state) {
      state.userInfo = {}
      removeItem(CONFIG.STORAGE_KEY)
    },
    // 删除token
    removeToken(state) {
      state.token = ''
      removeItem(CONFIG.TOKEN_KEY)
    },
  },
  // actions 中完成异步操作
  actions: {
    REGISTER(content, data) {
      return new Promise((resolve, reject) => {
        register(data).then(rdata => {
          if (rdata.code === 200 && rdata.data) {
            let userinfo = rdata.data.user
            userinfo.isLogin = true
            this.commit('auth/setToken', rdata.data.token)
            this.commit('auth/setUserInfo', userinfo)
            resolve(rdata)
          } else {
            reject(new Error(rdata.message))
          }
        })
      })
    },
    /** 手机号登陆
     * @param {Object} content
     * @param {Object} user
     */
    AUTH_LOGIN(content, user) {
      return new Promise((resolve, reject) => {
        const data = login({
            phone: user.phone,
            password: user.password,
            vcode: user.vcode
          })
          .then((res) => {
            if (res.code === 200) {
              let user = res.data
              this.commit('auth/setToken', user.token)
              this.commit('auth/setUserInfo', user.user)
            }
            resolve(res)
          }).catch((err) => {
            reject(err)
          })
      })
    },
    // 退出登陆
    AUTH_LOGOUT(context) {
      return new Promise((resolve, reject) => {
        logout().then((res) => {
          if (res.code === 200) {
            this.commit('auth/removeToken')
            this.commit('auth/removeUserInfo')
          }
          resolve(res)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    // 删除用户信息
    REMOVE_USER(content) {
      this.commit('auth/removeToken')
      this.commit('auth/removeUserInfo')
    },
    /**
     * 获取用户信息
     * @param {Object} content
     * @param {Object} user
     */
    GET_USER_INFO(content, user) {
      return new Promise((reslove, reject) => {
        getUserInfo({}).then((res) => {
          let {
            code,
            data
          } = res
          if (code === 200 && data) {
            this.commit('auth/setUserInfo', data.user)
          }
          reslove(res)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    // 验证token 是否正确
    async VERIFY_TOKEN(content, data) {
      await isCheckToken().then((res) => {
        if (res.code === 401) {
          this.commit('auth/removeToken')
          this.commit('auth/removeUserInfo')
          error('请登陆后操作')
          router.push({name: 'login'})
        }
      }).catch((err) => {
        console.log('isCheckToken err', err)
      })
    },
    // 进行登陆判定, 并跳转
    IS_LOGIN_JUMP(context) {
      if (context.state.token) {
        return true
      } else {
        MessageBox.confirm('需要登陆后才能操作, 是否登陆?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          router.push({name: 'login'})
        }).catch(() => {
          warning('已取消')        
        });
        return false
      }
    }
  },
}